import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { IPart, IPartResponse } from "../models/Part";
import { DefaultResponseWithData } from "../models/system";

export default function useVehicleOrders(vehicleId: string) {
  const { get, post, put } = useApiHelper();
  const queryClient = useQueryClient();
  const staleTime = 1000 * 60 * 60; //60 minutes - if this is shorter it will reset the price fields when it refetches

  const orders = useQuery({
    queryKey: ["orders", vehicleId],
    queryFn: () => get<DefaultResponseWithData<IPart[]>>(`/vehicle/partial/orders/${vehicleId}`),
    staleTime: staleTime,
  });

  return {
    orders
  };
}
